import { render } from "./MaterialCheckbox.vue?vue&type=template&id=42bdb2fa&scoped=true"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import "./MaterialCheckbox.vue?vue&type=style&index=0&id=42bdb2fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bdb2fa"]])

export default __exports__